import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from '@/store/modules/mobile/mobileCommonState/mobileCommon.store';
import axios, { AxiosResponse } from 'axios';
import graphQl from '@/services/graphQl';
import { Context } from '@/utils/types/global';
import graphHelpers from '@/utils/graphHelper';
import getEnv from '@/utils/env';
import allfragments from '@/services/graphQl/fragments/graph';
import { MetricName, OSType, Scope } from '@/components/Mobile/constants';
import fragmentAll from '@/store/modules/mobile/mobileCommonState/mobile.metrics.types';
import {
  NAV_TAB_KPI_USAGE,
  NAV_TAB_KPI_CRASHES,
  NAV_TAB_KPI_PERFORMANCE,
  NAV_TAB_MOBILE_DASHBOARD,
} from '@/components/Mobile/mobile.constants';
import axiosInstance from '@/services/api/http.service';
import router from '@/router';
const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';
const actions: ActionTree<State, any> = {
  getMobileGraphData(context: Context, params: any) {
    const { currentMobileService } =
      context.rootState.mobileState.mobileCommonState;
    /**
     *
     * variable  for determining the service type .
     * @description this is database query , if normal is true then the entity is database else it is for application
     * @param {boolean}
     */
    const normal = params.dashboardType.isDatabase ? false : true;
    const names = ['readSampledRecords', 'sortMetrics'];
    let config: any;
    // if (params.dashboardType.type === "Mobile") {
    //   config = graphHelpers.createConfigMobile(context, params);
    // } else {
    //   config = graphHelpers.createConfig(context, params);
    // }
    switch (context.rootState.mobileState.mobileCommonState.currentTab) {
      case NAV_TAB_KPI_USAGE:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.details[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          if (
            context.rootState.mobileState.mobileCommonState.currentTab ===
            NAV_TAB_KPI_USAGE
          ) {
            config =
              context.rootState.globalState.app.chartsTemplate.usage[
                params.layoutIndex
              ][params.index];
          } else if (
            context.rootState.mobileState.mobileCommonState.currentTab ===
            NAV_TAB_KPI_PERFORMANCE
          ) {
            config =
              context.rootState.globalState.app.chartsTemplate.performance[
                params.layoutIndex
              ][params.index];
          } else {
            config =
              context.rootState.globalState.app.chartsTemplate.performance[
                params.layoutIndex
              ][params.index];
          }
          break;
        }
      case NAV_TAB_KPI_CRASHES:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.details[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          config =
            context.rootState.globalState.app.chartsTemplate.details[
              params.layoutIndex
            ][params.index];
          break;
        }
      case NAV_TAB_KPI_PERFORMANCE:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.performance[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          config =
            context.rootState.globalState.app.chartsTemplate.performance[
              params.layoutIndex
            ][params.index];
          break;
        }
      case NAV_TAB_MOBILE_DASHBOARD:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.dashboardGauge[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          config =
            context.rootState.globalState.app.chartsTemplate.dashboardGauge[
              params.layoutIndex
            ][params.index];
          break;
        }
      default:
        config =
          context.rootState.globalState.app.chartsTemplate.details[
            params.index
          ];
        break;
    }
    if (!config || !config.metricName || !config.queryMetricType) {
      return;
    }
    const metricNames = graphHelpers.parse(config.metricName);
    const labels = graphHelpers.parse(config.labelsIndex || '');
    /**
     * @description add the current Mobile service
     * @param {string}
     */
    const currentMobileId = config.independentSelector
      ? config.currentMobileService
      : currentMobileService.key;
    let variablesList: any;
    if (
      config.customMetricName === 'crashByFilter' ||
      config.customMetricName === 'usage'
    ) {
      if (context.rootState.globalState.settings.isCompareOptionsSelected) {
        variablesList = [
          {
            request: {
              duration: params.duration,
              filterType: config.filterType,
              serviceId: currentMobileId,
              os: context.getters.getCurrentMobileOS.key,
              versionId: context.getters.getCurrentMobileAppVersion.key,
            },
            requestCompared: {
              duration: params.compareDuration,
              filterType: config.filterType,
              serviceId: currentMobileId,
              os: context.getters.getCurrentMobileOS.key,
              versionId: context.getters.getCurrentMobileAppVersion.key,
            },
          },
        ];
      } else {
      variablesList = [
        {
          request: {
            duration: params.duration,
            filterType: config.filterType,
            serviceId: currentMobileId,
            os: context.getters.getCurrentMobileOS.key,
            versionId: context.getters.getCurrentMobileAppVersion.key,
          },
        },
      ];
    }
    } else if (
      config.customMetricName === 'activeUsersByOs' ||
      config.customMetricName === 'appEventsByOs' ||
      config.customMetricName === 'newRegisteredUsers'
    ) {
      if (context.rootState.globalState.settings.isCompareOptionsSelected) {
        variablesList = [
          {
            condition: {
              duration: params.duration,
              serviceId: currentMobileId,
              os: context.getters.getCurrentMobileOS.key,
              versionId:
                context.getters.getCurrentMobileAppVersion.label === 'All'
                  ? []
                  : [context.getters.getCurrentMobileAppVersion.label],
            },
            conditionCompared: {
              duration: params.compareDuration,
              serviceId: currentMobileId,
              os: context.getters.getCurrentMobileOS.key,
              versionId:
                context.getters.getCurrentMobileAppVersion.label === 'All'
                  ? []
                  : [context.getters.getCurrentMobileAppVersion.label],
            }
          },
        ];
      } else {
      variablesList = [
        {
          condition: {
            duration: params.duration,
            serviceId: currentMobileId,
            os: context.getters.getCurrentMobileOS.key,
            versionId:
              context.getters.getCurrentMobileAppVersion.label === 'All'
                ? []
                : [context.getters.getCurrentMobileAppVersion.label],
          },
        },
      ];
    }
    } else if (
      config.queryMetricType === 'readCustomMetricsValues' &&
      config.entityType === 'Mobile'
    ) {
      const condition = {
        name: config.metricName,
        entity: {
          scope: 'Mobile',
          serviceName: currentMobileId,
          normal: true,
          os: context.getters.getCurrentMobileOS.key,
          versionIds: context.getters.getCurrentMobileAppVersion.key,
        },
      };
    
      variablesList = [
        {
          duration: params.duration,
          condition: condition,
          ...(context.rootState.globalState.settings.isCompareOptionsSelected && { durationCompare: params.compareDuration }),
        },
      ];
    } else if (
      config.queryMetricType === 'readMetricsValue' &&
      config.entityType === 'Service'
    ) {
      variablesList = [
        {
          duration: params.duration,
          condition: {
            name: config.metricName,
            entity: {
              scope: 'Service',
              serviceName: currentMobileId,
              normal: true,
              os: context.getters.getCurrentMobileOS.key,
              //versionIds: context.getters.getCurrentMobileAppVersion.key
              teamID: context.rootState.globalState.user.teamID,
            },
          },
          labels: [],
        },
      ];
    } else {
      variablesList = graphHelpers.createVariableList(
        metricNames,
        params,
        config,
        names,
        labels,
        normal,
        currentMobileId,
      );
    }
    if (context.rootState.globalState.settings.isCompareOptionsSelected && (config.queryMetricType === "readMetricsValues"))  {
      variablesList = variablesList.map(variable => {
        return {
          ...variable,
          durationCurrent: params.duration,
          durationCompare: params.compareDuration,
          duration: undefined,
        };
      });
    }
    if (!variablesList || !variablesList.length) {
      return;
    }
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          if (variable.request || config.isUsages) {
            let fragments, queryVariables;
            const isCompareOptionSelected = context.rootState.globalState.settings.isCompareOptionsSelected;
            if(context.rootState.globalState.settings.isCompareOptionsSelected  && (config.customMetricName === 'activeUsersByOs' ||  config.customMetricName === 'appEventsByOs' || config.customMetricName === 'newRegisteredUsers' || config.customMetricName === 'usage' || config.customMetricName === 'crashByFilter')) {
              fragments = allfragments[config.customMetricName + "Compare"].query;
              queryVariables = allfragments[config.customMetricName+ "Compare"].variable;
            } else {
              fragments = allfragments[config.customMetricName].query;
              queryVariables =
                allfragments[config.customMetricName].variable;
            }
            const query = `query ${config.customMetricName}(${queryVariables}) {${fragments}}`;
            axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            return new axiosInstance({ auth: true })
              .post(
                OAP_HOST + '/graphql',
                { query, variables: variable },
                {
                  // cancelToken: cancelToken()
                },
              )
              .then((res: AxiosResponse<any>) => {
                let resData = res.data.data?.response?.values;
                let resDataCompared = res.data.data?.responseCompared?.values;
    
                let _tempArray: Object[] = [];
                _tempArray[config.queryMetricType] = [];
                if (!(resData instanceof Array)) {
                  let _tempObj = {
                    label: config.customMetricName,
                    values: {
                      values: resData.values.map((i: any) => i.value),
                    },
                  };
                  _tempArray[config.queryMetricType] = _tempObj;
                  if (isCompareOptionSelected) {
                    let _tempObjCompared = {
                      label: config.customMetricName + 'Compared',
                      values: {
                        values: resDataCompared.values.map((i: any) => i.value),
                      },
                    };
                    _tempArray["compared"] = _tempObjCompared;
                  }
                  return {
                    ..._tempArray,
                    config,
                    metricName: config.customMetricName,
                  };
                }
                resData.forEach((element, index) => {
                  let _tempObj = {
                    label: element.key,
                    values: {
                      values: element.values,
                    },
                  };
                  _tempArray[config.queryMetricType] = [];
                  if (config.responseType !== 'dynamic' || config.responseType === 'undefined' ) {
                    _tempArray[config.queryMetricType] = _tempObj;
                  } else {
                    _tempArray[config.queryMetricType][index] = _tempObj;
                  }
                }); 
                if(isCompareOptionSelected) {
                  _tempArray['compared'] = [];
                  if (resDataCompared.length !== 0) {
                resDataCompared?.forEach((element, index) => {
                    let _tempObjCompared = {
                      label: element.key,
                      values: {
                        values: element.values,
                      },
                    }
                    if(config.responseType !== 'dynamic' || config.responseType === 'undefined') {
                    _tempArray['compared'] = _tempObjCompared;
                } else {
                  _tempArray['compared'][index] = _tempObjCompared;
                }
                  });
                }
              }
                return {
                  ..._tempArray,
                  config,
                  metricName: variable.request.filterType,
                };
              });
          } else {
            const currentSetMobileOS =
              context.rootState.mobileState.mobileCommonState.currentMobileOS;
            const currentVersion =
              context.rootState.mobileState.mobileCommonState
                .currentMobileAppVersion;
            const selectedMobileOSs = currentSetMobileOS
              ? currentSetMobileOS
              : { key: OSType.OS_ALL, label: 'All' };
            if (config.isCrashes) {
              if (currentVersion.key && currentVersion.key != 'all') {
                variable.condition.entity['scope'] = Scope.SERVICEINSTANCE;

                variable.condition.entity['serviceInstanceName'] =
                  currentVersion.key;
                variable.condition.name =
                  MetricName.MOBILE_APP_VERSION_CRASH_COUNT;
              } else {
                if (selectedMobileOSs.key === OSType.OS_ALL) {
                  variable.condition.name = MetricName.MOBILE_APP_CRASH_COUNT;
                  config.metricName = MetricName.MOBILE_APP_CRASH_COUNT;
                }
                if (selectedMobileOSs.key === OSType.OS_IOS) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_CRASH_IOS_COUNT;
                  config.metricName = MetricName.MOBILE_APP_CRASH_IOS_COUNT;
                }
                if (selectedMobileOSs.key === OSType.OS_ANDROID) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_CRASH_ANDROID_COUNT;
                  config.metricName = MetricName.MOBILE_APP_CRASH_ANDROID_COUNT;
                }
              }
            }
            if (config.isPerformance) {
              if (currentVersion.key && currentVersion.key != 'all') {
                variable.condition.entity['scope'] = Scope.SERVICEINSTANCE;
                variable.condition.entity['serviceInstanceName'] =
                  currentVersion.key;
                variable.condition.name = MetricName.MOBILE_APP_VERSION_COUNT;
              } else {
                if (selectedMobileOSs.key === OSType.OS_ALL) {
                  variable.condition.name = MetricName.MOBILE_APP_NORMAL_COUNT;
                  config.metricName = MetricName.MOBILE_APP_NORMAL_COUNT;
                }
                if (selectedMobileOSs.key === OSType.OS_IOS) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_IOS_NORMAL_COUNT;
                  config.metricName = MetricName.MOBILE_APP_IOS_NORMAL_COUNT;
                }
                if (selectedMobileOSs.key === OSType.OS_ANDROID) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_ANDROID_NORMAL_COUNT;
                  config.metricName =
                    MetricName.MOBILE_APP_ANDROID_NORMAL_COUNT;
                }
              }
            }
            if (config.isPerformanceResponseTime) {
              if (currentVersion.key && currentVersion.key != 'all') {
                variable.condition.entity['scope'] = Scope.SERVICEINSTANCE;
                variable.condition.entity['serviceInstanceName'] =
                  currentVersion.key;
                variable.condition.name =
                  MetricName.MOBILE_APP_PERF_VERSION_RESPONSE_TIME;
              } else {
                if (selectedMobileOSs.key === OSType.OS_ALL) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_PERF_RESPONSE_TIME;
                  config.metricName = MetricName.MOBILE_APP_PERF_RESPONSE_TIME;
                }
                if (selectedMobileOSs.key === OSType.OS_IOS) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_PERF_IOS_RESPONSE_TIME;
                  config.metricName =
                    MetricName.MOBILE_APP_PERF_IOS_RESPONSE_TIME;
                }
                if (selectedMobileOSs.key === OSType.OS_ANDROID) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_PERF_ANDROID_RESPONSE_TIME;
                  config.metricName =
                    MetricName.MOBILE_APP_PERF_ANDROID_RESPONSE_TIME;
                }
              }
            }
            if (
              config.queryMetricType === 'readMetricsValue' &&
              config.entityType === 'Service'
            ) {
              const fragments = fragmentAll[config.queryMetricType].fragment;
              const queryVariables =
                fragmentAll[config.queryMetricType].variable;
              const query = `query queryData(${queryVariables}) {${fragments}}`;
              return new axiosInstance({ auth: true })
                .post(
                  OAP_HOST + '/graphql',
                  { query, variables: variable },
                  {
                    // cancelToken: cancelToken()
                  },
                )
                .then((res: AxiosResponse<any>) => {
                  const resData = res.data.data;
                  return {
                    ...resData,
                    config,
                    metricName: variable.condition.name,
                  };
                });
            }
            let metricType;
            if(context.rootState.globalState.settings.isCompareOptionsSelected) {
             metricType = config.queryMetricType + "Compare";
            }else
            metricType = config.queryMetricType
            return graphQl
              .graphQuery(variable, metricType)
              .then((res: AxiosResponse<any>) => {
                let resData = res.data.data;
                return {
                  ...resData,
                  config,
                  metricName: variable.condition.name,
                };
              });
          }
        } else {
          return { config };
        }
      }),
    )
      .then((data: any) => {
        return data;
      })
      .catch((err) => console.log('error', err));
  },
  async GET_OSs(
    context: { commit: Commit; rootState: any },
    params: any,
  ): Promise<any> {
    context.commit('setMobileOS', params);
  },
  async GET_MOBILE_SERVICES(
    context: { commit: Commit; rootState: any },
    params: { serviceReq: any; duration: any },
  ): Promise<any> {
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'M',
      };
    }
    return graphQl
      .query('queryServices')
      .params(params)
      .then(async (res: AxiosResponse) => {
        let services = new Array();
        if (
          router.currentRoute.value &&
          router.currentRoute.value.name === 'mblDashboard'
        ) {
          services.push({ key: 'all', label: 'All' });
        }
        services.push(...res.data.data.services);
        context.commit('setMobileServices', services);
      })
      .catch((err) => err);
  },
  async GET_MOBLIE_SERVICE_INSTANCES(
    context: { commit: Commit; rootState: any },
    params: { serviceId: any; duration: any },
  ): Promise<any> {
    if (!params.serviceId) {
      return;
    }
    return graphQl
      .query('queryInstacesForMobile')
      .params(params)
      .then(async (res: AxiosResponse) => {
        let serviceInstances = res.data.data.getServiceInstances;
        let allIOSAppVersions: any[] = [];
        let allAndroidAppVersions: any[] = [];
        if (serviceInstances) {
          serviceInstances.forEach((element) => {
            if (element.attributes.length > 0) {
              if (
                element.attributes[0].name === 'OS' &&
                element.attributes[0].value === OSType.OS_IOS
              ) {
                allIOSAppVersions.push({
                  key: element.key,
                  label: element.label,
                });
              }
              if (
                element.attributes[0].name === 'OS' &&
                element.attributes[0].value === 'Android'
              ) {
                allAndroidAppVersions.push({
                  key: element.key,
                  label: element.label,
                });
              }
            }
          });
        }
        context.commit('setAllIOSAppVersions', allIOSAppVersions);
        context.commit('setAllAndroidAppVersions', allAndroidAppVersions);
        context.commit(
          'setMobileAppVersion',
          res.data.data.getServiceInstances,
        );
      })
      .catch((err) => console.log('error', err));
  },
  async selectMobileService(
    context: { commit: Commit; dispatch: Dispatch },
    params: { key: any },
  ): Promise<any> {
    if (!params.key) {
      return;
    }
    context.commit('setCurrentMobileService', params);
  },
  async selectMobileOSs(
    context: { commit: Commit; dispatch: Dispatch },
    params: any,
  ): Promise<any> {
    if (!params) {
      return;
    }
    context.commit('setCurrentMobileOS', params);
  },
  async selectMobileCurrentAppVersion(
    context: { commit: Commit; dispatch: Dispatch },
    params: any,
  ): Promise<any> {
    if (!params) {
      return;
    }
    context.commit('setCurrentMobileAppVersion', params);
  },
};
export default actions;
